import { AppRouter } from "./router";

// Safely access globalThis and provide fallback values
function App() {
  return <AppRouter />;
}

export default App;
